import {defineStore} from 'pinia'

export const useEventsStore = defineStore('events', {
    state: () => ({
        expandCollapseSessionDescriptionState: '',
        hasDisplayedConflictNag: false,
        isSingleProgramEvent: false,
        newSignIn: false,
        scheduleRoute: null,
    }),
})